import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/sub-component/Button";
import Emoji from "../../../assets/icons/onboarding/Emoji.svg";
import Checkbox from "../../../components/sub-component/Checkbox";
import { patchAssessment } from "../../../redux/thunks/Assessment";
import ProcessingIndicator from "../../../components/common/ProcessingIndicator";
import { ReactComponent as ShieldIcon } from "../../../assets/icons/candidate-assessment/shield.svg";
import { ReactComponent as TestFuseWatermarkIcon } from "../../../assets/icons/candidate-assessment/Watermark.svg";

export default function VideoConsent(props) {
  const { assessment, submitVideoConsent, setSubmitVideoConsent } = props;
  const params = useParams();
  const dispatch = useDispatch();

  const handlePatchAssessment = (data) => {
    dispatch(patchAssessment({ id: params.id, data }));
  };

  return (
    <div className="candidate-assessment-flow-container">
      <div
        className="candidate-assment-flow-wrapper"
        style={{ height: "80vh" }}
      >
        <div
          className="d-flex flex-column align-items-center"
          style={{
            maxWidth: "684px",
            padding: "24px",
            gap: "24px",
            borderRadius: "24px",
            backgroundColor: "white",
          }}
        >
          <div
            className="d-flex flex-column align-items-center"
            style={{
              padding: "24px",
              gap: "24px",
            }}
          >
            <ShieldIcon />
            <span className={`headline-4 dark-100 text-center`}>
              Video Response Consent
            </span>
            <div
              className="d-flex flex-column align-items-start"
              style={{ gap: "24px" }}
            >
              <span className="body-2 dark-50 text-start">
                This section of the assessment includes video questions.
              </span>
              <span className="body-2 dark-50 text-start">
                By proceeding, you consent to:
              </span>
              <li className="body-2 dark-50 text-start">
                Video and Audio Recording: Your camera and microphone will be
                used to record your answers.
              </li>
              <li className="body-2 dark-50 text-start">
                Automated Analysis: These recordings will be algorithmically
                analyzed for personality insights by converting your speech to
                text, and then analyzing the text.
              </li>
              <span className="body-2 dark-50 text-start">
                Your video responses will be stored for 24 months. For full
                details, please review our{" "}
                <a
                  href={`${window._env_.TF_LANDING_SITE_URL}/biometric-information-policy`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className=" dark-100"
                >
                  Biometric Information Policy.
                </a>
              </span>
              <div className="w-100 d-flex flex-row" style={{ gap: "12px" }}>
                <div>
                  <Checkbox
                    primary
                    onChange={() => {
                      setSubmitVideoConsent(true);
                    }}
                    checked={submitVideoConsent}
                  />
                </div>
                <span className="body-2 text-start">
                  I agree to record my video responses under these terms.
                </span>
              </div>
            </div>
          </div>
          <div
            className="login-input-group w-100 d-flex align-items-end justify-content-end"
            style={{ padding: "24px 0px", borderTop: "1px solid #ECEDF1" }}
          >
            <Button
              btn="ragular-btn"
              varrient="primary"
              title={"Start Assessment"}
              style={{ width: "max-content", height: "40px" }}
              disabled={!submitVideoConsent}
              onClick={() => {
                handlePatchAssessment({
                  has_submitted_video_resp_consent: true,
                  has_submitted_integrity_consent:
                    assessment?.has_submitted_integrity_consent,
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
